import { z } from 'zod'

/** Represents the enum public.api_key_type_ */
enum ApiKeyType {
  READONLY = 'READONLY',
  CAPTUREAPP = 'CAPTUREAPP',
  SDM = 'SDM',
  ETHERNET_ACTIVATOR = 'ETHERNET_ACTIVATOR',
  ERPNEXT = 'ERPNEXT',
  CHROME_EXTENSION = 'CHROME_EXTENSION',
  CLI = 'CLI',
  MCP = 'MCP',
  MODELFACTORY = 'MODELFACTORY',
  SEA_ICE_PROVIDER = 'SEA_ICE_PROVIDER',
}

export default ApiKeyType

/** Zod schema for api_key_type_ */
export const apiKeyType = z.enum([
  'READONLY',
  'CAPTUREAPP',
  'SDM',
  'ETHERNET_ACTIVATOR',
  'ERPNEXT',
  'CHROME_EXTENSION',
  'CLI',
  'MCP',
  'MODELFACTORY',
  'SEA_ICE_PROVIDER',
])
